import { TriangleAlert, Upload } from 'lucide-react';
import { clsx } from '../../../ds/clsx';
import styles from './Documents.module.css';

export interface UploadItem {
  key: string;
  name: string;
  /** The request the file delivers („Für Anforderung"), shown in the category column. */
  requestTitle: string | null;
  progress: number;
  error: string | null;
  abort: (() => void) | null;
}

/**
 * Portal 18, the running upload: `--accent-soft` row with the progress bar, „wird geladen" and „Abbrechen" (aborts
 * the request). A refused file keeps the row in the danger state with the server's text and „Entfernen" (own).
 */
export function UploadRow({ item, onDismiss }: { item: UploadItem; onDismiss: (key: string) => void }) {
  const percent = Math.round(item.progress * 100);
  return (
    <div className={clsx(styles.row, item.error ? styles.rowError : styles.rowUploading)} role="row">
      <div className={styles.nameCell} role="cell">
        {item.error ? (
          <TriangleAlert size={18} strokeWidth={1.5} aria-hidden="true" className={styles.errorIcon} />
        ) : (
          <Upload size={18} strokeWidth={1.5} aria-hidden="true" className={styles.uploadIcon} />
        )}
        <div className={styles.nameText}>
          <div className={styles.name}>{item.name}</div>
          {item.error ? (
            <div className={styles.rowErrorText} role="alert">
              {item.error}
            </div>
          ) : (
            <div
              className={styles.progress}
              role="progressbar"
              aria-label={`${item.name} wird hochgeladen`}
              aria-valuemin={0}
              aria-valuemax={100}
              aria-valuenow={percent}
            >
              <div className={styles.progressFill} style={{ width: `${percent}%` }} />
            </div>
          )}
        </div>
      </div>
      <span className={styles.cell} role="cell">
        {item.requestTitle ?? ''}
      </span>
      <span className={styles.cell} role="cell">
        Von mir
      </span>
      <span className={clsx(styles.cell, styles.tabular)} role="cell">
        {item.error ? 'nicht übernommen' : 'wird geladen'}
      </span>
      <span className={styles.actionCell} role="cell">
        {item.error ? (
          <button type="button" className={styles.action} onClick={() => onDismiss(item.key)}>
            Entfernen
          </button>
        ) : (
          <button type="button" className={styles.action} onClick={() => item.abort?.()}>
            Abbrechen
          </button>
        )}
      </span>
    </div>
  );
}
